import {
  ClockOutlineIcon,
  Popover,
  PopoverTrigger,
  PopoverMenu,
  PopoverMenuItem,
  PopoverMenuItemSeparator,
} from "@tandemdiabetes/sugarmate-react-components"
import { Fragment } from "react"
import {
  useGraphContext,
  zoomLevels,
} from "../GraphContext"
import styles from "./GraphHeaderButton.module.scss"
import { usePolyglot } from "src/contexts"

const polyglotPrefix = "pages.home.graph.header.zoom."

export function GraphZoomButton() {
  const polyglot = usePolyglot()
  const {
    zoom,
    setZoom,
  } = useGraphContext()

  return (
    <Popover placement="bottom-start">
      <PopoverTrigger
        className={styles.button}
        id="zoom-button"
      >
        {polyglot.t(
          "time.hr",
          zoom,
        )}
        <ClockOutlineIcon />
      </PopoverTrigger>
      <PopoverMenu
        aria-label={polyglot.t(`${polyglotPrefix}aria_label`)}
      >
        {zoomLevels.map((zoomLevel, index) => {
          const onClick = () => setZoom(zoomLevel)

          return (
            <Fragment key={zoomLevel}>
              {index !== 0 && <PopoverMenuItemSeparator />}
              <PopoverMenuItem
                onClick={onClick}
                id="zoom-level"
                autoDismiss
              >
                {polyglot.t(
                  "time.hr",
                  zoomLevel,
                )}
              </PopoverMenuItem>
            </Fragment>
          )
        })}
      </PopoverMenu>
    </Popover>
  )
}
